
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { Row, Col } from "react-bootstrap";
// import PopupApcode from './../../../PopUp/PopUpApcode'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
// import PopUpOther from "./../../../PopUp/PopUpOther";
import FullScreenDialog from "./../../../PopUp/FullScreendialogs"
import { genURL, gengetURLTEST } from "./../../../_getjson.js";
import axios from 'axios'
import Moment from 'moment';

import Grid from '@mui/material/Grid';
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Inputtax0(props) {
    const { parm } = props
    const Docgroupcode = useRef(null);
    const Docgroup = useRef(null);
    const [Rungroup, setRungroup] = useState("")
    const Totaltax0 = useRef();
    const [Docgrouptxt, setDocgrouptxt] = useState("")
    const [value, setValue] = React.useState(0);

    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [listitem1, setlistitem1] = useState([]);
    const [bakup0, setbakup0] = useState(parm[1]);
    const [bakup1, setbakup1] = useState(parm[2]);
    const [tableInputtax2, settableInputtax2] = useState("");

    useEffect(() => {
        console.log(parm[2]);
        // หน้าหลัก
        Get_CSDOCGROUP(parm[0].Docgroupcode0)
        Totaltax0.current.value = parseFloat(parm[0].Totaltax0).toFixed(2)
    }, []);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const Switch_OtherPopup = (type) => {
        let pram = {
            type: type,
            from: "CSAPWTAX_RUN",
        }
        setdataMultipletax(pram)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog("ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP")
        settypeFullScreenDialog(type)
    };
    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e);
        if (e) {
            let data = e[1].split('|')
            if (typeFullScreenDialog === 'Groupdataall') {
                Docgroupcode.current.value = data[0]
                Docgroup.current.value = data[1]
                setDocgrouptxt(data[1]);
            }
        }
    }
    const onClick = (e) => {
        if (e.target.name === "Docgroup") {
            Docgroup.current.value = Docgroupcode.current.value
            Docgroup.current.select()
        }
    }
    const onBlur = (e) => {
        if (e.target.name === "Docgroup") {
            Docgroup.current.value = Docgrouptxt
        }
    }
    const sendData = (e) => {
        let resdata = []
        resdata.push(e)
        props.resdata(resdata)
    }
    const onBlurAction = (e) => {
        switch (e.target.name) {
            case "Totaltax0": Totaltax0.current.value = parseFloat(e.target.value).toFixed(2); break;
            default:
                break;
        }
    }
    const Get_CSDOCGROUP = (code) => {
        var url = "CSDOCGROUP/Searchbycode?code=" + code + "&tablename=CSAPWTAX_RUN"
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
            if (res.data.length > 0) {
                Docgroupcode.current.value = res.data[0].CODE
                Docgroup.current.value = res.data[0].MYNAMETH
                setDocgrouptxt(res.data[0].MYNAMETH)
                setRungroup(res.data[0].RUNGROUP);
            } else {
                Docgroupcode.current.value = ("")
                Docgroup.current.value = ("")
                setDocgrouptxt("")
                setRungroup("");
            }
        })
    }
    const sumdata = async (name, data) => {
        console.log(name, data);
        if (name === "Inputtax1" && data.sum) {
            Totaltax0.current.value = await data.sum
        }
        if (name === "Inputtax2" && data.sumTax) {
            Totaltax0.current.value = await data.sumTax
        }
        let resdata = []
        resdata.push(true)
        let data0 = ""
        data0 = {
            Docgroupcode0: Docgroupcode.current.value,
            Totaltax0: Totaltax0.current.value,
        }
        resdata.push(data0)

        var data1 = ""
        var data2 = ""
        var table = []
        if (name === "Inputtax1") {
            let Totaltax1 = data.Totaltax1 ? data.Totaltax1 : bakup0.Totaltax1
            let Vat = data.Vat ? data.Vat : bakup0.Vat
            data1 = await {
                PaymentDocno: parm[1].PaymentDocno,
                Refdocno: parm[1].Refdocno,
                Totaltax1: Totaltax1,
                Vat: Vat,
                Inputtax1: data.listitem
            }
            setbakup0(data1)
            if (data.sum) {
                var j = 0
                for (let i = 0; i < data.listitem.length && data.listitem[i].PRODUCTCODE; i++) {
                    var sum = ""
                    var result = ""
                    // console.log(Moment(new Date()).format('YYYY-MM-DD'));
                    let Deliverydate1 = Moment(new Date()).format('YYYY/MM/DD')
                    let Date0 = Deliverydate1.split('/')
                    if (Rungroup) {
                        sum = Rungroup + '-TT' + (Date0[1]) + '-'
                    }
                    var Sum1 = ""
                    var url = "CSAPWTAXRUN/Search?Code=" + sum
                    console.log(genURL(url));
                    await axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
                        if (res.data) {
                            result = await res.data
                            let numbertax = 0
                            var order = ""
                            var TAXNO = result.split('-')
                            numbertax = Number(TAXNO[2])
                            let number = numbertax + 1
                            if (number > 0 && number < 10) {
                                order = "00" + number
                                console.log(order);
                            }
                            if (number > 9 && number < 100) {
                                order = "0" + number
                                console.log(order);
                            }
                            if (number > 99) {
                                order = number
                                console.log(order);
                            }
                            Sum1 = await TAXNO[0] + "-" + TAXNO[1] + "-" + order
                            console.log(Sum1);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                    var url1 = "CSINCOMETYPE/Search?Code=" + data.listitem[i].INCOMETYPE
                    console.log(genURL(url1));
                    let Income = ""
                    let Incomecode = ""
                    await axios.get(genURL(url1), { timeout: 60000 }).then(async (res) => {
                        if (res.data.length > 0) {
                            Income = await res.data[0].MYNAMETH
                            Incomecode = await res.data[0].CODE
                        }
                    })

                    table[i] = await {
                        numrow: i + 1,
                        Taxinvoice: i < 1 ? result : Sum1,
                        Income: Income,
                        Incomecode: Incomecode,
                        Invoicedate: Moment(new Date()).format('YYYY-MM-DD'),
                        PayableCode: parm[2].APCode,
                        PayableName: parm[2].APName,
                        Remark: data.listitem[i].PRODUCTNAME,
                        Taxdescription: data.listitem[i].WTAXRATE,
                        Amountbeforetax: data.listitem[i].AMOUNT,
                        Tax: data.listitem[i].TAXAMOUNT,
                        PayableCode1: parm[2].APCode,
                        Condition: '1',
                    }
                    j = i
                }
                if (j > 0) {
                    for (let i = 0; i < 20 + (j + 1); i++) {
                        if (i > j) {
                            table[i] = await {
                                numrow: i + 1,
                            }
                        }
                    }
                    settableInputtax2(table)
                    data2 = await {
                        APCode: parm[2].APCode,
                        APName: parm[2].APName,
                        // ข้อมูลในตาราง
                        Inputtax2: (table),
                    }
                    setbakup1(data2)
                }
            }
        }
        resdata.push(data1)

        if (name === "Inputtax2") {
            data2 = await {
                APCode: parm[2].APCode,
                APName: parm[2].APName,
                // ข้อมูลในตาราง
                Inputtax2: (tableInputtax2 ? tableInputtax2 : data.listitem),
            }
            setbakup1(data2)
        }
        resdata.push(data2)
        props.resdata(resdata)

    }
    return (
        <div className="panel-body DivTable">
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="ชำระค่าบริการ" {...a11yProps(0)} />
                        <Tab label="ภาษีหัก ณ ที่จ่าย" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Inputtax1 parm={bakup0} sumdata={(e, e1) => sumdata(e, e1)} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Inputtax2 parm={bakup1} sumdata={(e, e1) => sumdata(e, e1)} />
                </TabPanel >
                {/* <div style={{ margin: '25px' }}> */}
                <Grid>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">กลุ่มภาษีหัก ณ ที่จ่าย  </span>
                                    <input type="text" className="form-control hidden" ref={Docgroupcode} id="Docgroupcode" name="Docgroupcode" />
                                    <input type="text" className="form-control" ref={Docgroup} id="Docgroup" name="Docgroup" onClick={onClick} onBlur={onBlur} />
                                    <span id="Groupdataall" className="input-group-addon icon" onClick={() => Switch_OtherPopup("Groupdataall")}>
                                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                    </span>
                                </div>
                            </div>
                        </Row>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={4} sm={12} md={4} lg={4}>
                            </Col>
                            <Col xs={4} sm={12} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <Button variant="outlined" size="small" onClick={e => sendData(false)}> ตกลง </Button>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={4} sm={12} md={4} lg={4}>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">รวมยอดภาษี  </span>
                                            <input type="text" className="form-control" ref={Totaltax0} name="Totaltax0" onBlur={e => onBlurAction(e)} />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
                {/* </div> */}
            </Box>

        </div>
    )
}
Inputtax0.prototype = {
    parm: PropTypes.array
}

function Inputtax1(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const Totaltax1 = useRef();
    const Vat = useRef();
    const [WHRow1, setWHRow1] = useState("");
    const [col2, setcol2] = useState("");
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [rowid, setrowid] = useState("");
    const [refdocno, setrefdocno] = useState("");
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        console.log('Inputtax1', parm);
        Totaltax1.current.value = parseFloat(parm.Totaltax1).toFixed(2)
        Vat.current.value = parseFloat(parm.Vat).toFixed(2)
        setrefdocno(parm.Refdocno)
        if (parm.Inputtax1.length > 0) {
            //     var url = "CSPREPAYITEMWTAX/GET?DOCNO=" + parm.PaymentDocno
            //     console.log(genURL(url));
            //     axios.get(genURL(url), { timeout: 50000 }).then((res) => {
            //         if (res.data.length > 0) {
            setListitem(parm.Inputtax1)
            //             var refdocno = ""
            //             for (let i = 0; i < res.data.length; i++) {
            //                 refdocno += res.data[i].REFDOCNO + "|"
            //             }
            //             setrefdocno(refdocno)
            //         }
            //     })

        } else {
            let item = []
            for (let index = 0; index < 15; index++) {
                item[index] = {
                    Taxinvoice: "",
                    Invoicedate: "",
                    PayableCode: "",
                    PayableName: '',
                    Taxdescription: "",
                    Amountbeforetax: "",
                    Tax: "",
                }
                setListitem(item)
            }
        }
    }
    const onRowClick = (data, col, id) => {
        setWHRow1(id);
        setcol2(false);
        if (col === 1) {
            if (!data.PayableCode) {
                listitem[id].Invoicedate = Moment(new Date()).format('YYYY-MM-DD')
                listitem[id].PayableCode = parm[0]
                listitem[id].PayableName = parm[1]
                listitem[id].Condition = '1'
            }
        }
        if (data.Taxinvoice) {
            setcol2(true);
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
            if (col === 2) {
                data.btn_income = 1
                data.Income = data.Incomecode
            }
            if (col === 6) {
                data.btn_C3 = 1
            }
            if (col === 14) {
                data.btn_type = 1
                data.Type = data.Typecode
            }
            if (col === 16) {
                data.btn_C4 = 1

            }
        } else {
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
            listitem[id].Condition = ''
        }

    }
    const onAfterSaveCell = (row, cellName, cellValue) => {
        for (let index = 0; index < listitem.length; index++) {
            if (listitem[index].Taxinvoice === "") {
                listitem[index].Invoicedate = ""
                listitem[index].PayableCode = ""
                listitem[index].PayableName = ""
                listitem[index].Tax = ""
            }
        }
        let id = row.numrow - 1
        if (cellName === 'Type' && row.Type) {
            var url = "CSWTAXTYPE/Search?Code=" + row.Type
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Typecode = await res.data[i].CODE
                        listitem[id].Type = await res.data[i].MYNAMETH
                    }
                } else {
                    listitem[id].Typecode = await ""
                    listitem[id].Type = await ""
                }
                setListitem([...listitem])
            })
        }
        if (cellName === 'Income' && row.Income) {
            var url = "CSINCOMETYPE/Search?Code=" + row.Income
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Incomecode = await res.data[i].CODE
                        listitem[id].Income = await res.data[i].MYNAMETH
                        listitem[id].Taxdescription = await res.data[i].WTAXRATE
                    }
                } else {
                    listitem[id].Incomecode = await ""
                    listitem[id].Income = await ""
                    listitem[id].Taxdescription = await ""
                }
                setListitem([...listitem])
            })
        }
        if (cellName === 'Amountbeforetax') {
            if (listitem[id].Taxinvoice) {
                console.log(cellValue);
                let res = (Number(listitem[id].Taxdescription) / 100) * Number(cellValue)
                console.log(res);
                row.Tax = parseFloat(res).toFixed(2)
            }
        }
        setTimeout(() => {
            SumCalculate(cellName)
        }, 50);
    }
    const onBeforeSaveCell = (row, cellName, cellValue) => {

    }



    const SumCalculate = (cellName) => {
        let sumTax = 0
        for (let index = 0; index < listitem.length && listitem[index].Taxinvoice; index++) {
            if (listitem[index].Tax !== "") {
                sumTax += Number(listitem[index].Tax)
            }
        }
        setTimeout(() => {
            if (sumTax > 0) {
                Totaltax1.current.value = parseFloat(sumTax).toFixed(2)
            }
        }, 50);
    }
    const onBlurAction = (e) => {
        if (e.target.value && e.target.type === "number") {
            e.target.value = parseFloat(e.target.value).toFixed(2)
        }
    }
    const Switch_OtherPopup1 = (type, row, dialog) => {
        setrowid(row)
        let pram = { type: type }
        setdataMultipletax(pram)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog(dialog)
        settypeFullScreenDialog(type)
    };
    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e);
        if (e) {
            let data = e[1].split('|')
            let id = rowid - 1
            if (typeFullScreenDialog === 'Incometype') {
                listitem[id].Incomecode = data[0]
                listitem[id].Income = data[1]
                listitem[id].Taxdescription = data[2]
            }
            if (typeFullScreenDialog === 'Apcode') {
                listitem[id].PayableCode = data[0]
                listitem[id].PayableName = data[1]
            }
            if (typeFullScreenDialog === 'taxtype') {
                listitem[id].Typecode = data[0]
                listitem[id].Type = data[1]
            }
            if (typeFullScreenDialog === 'Apcode1') {
                listitem[id].PayableCode1 = data[0]
            }
        }
    }
    const Cleartable = () => {
        let item = []
        for (let index = 0; index < 15; index++) {
            item[index] = {
                Taxinvoice: "",
                Invoicedate: "",
                PayableCode: "",
                PayableName: '',
                Taxdescription: "",
                Amountbeforetax: "",
                Tax: "",
            }
            setListitem(item)
        }
        let resdata = {
            Totaltax1: 0,
            Vat: 0,
            sum: 0,
            listitem: item
        }
        props.sumdata('Inputtax1', resdata)
    }
    const Getcsv_APPAYWTAX = async () => {
        console.log(refdocno);
        var url = "CSV_APPAYWTAX/GET?Top=100&REFDOCNO=" + refdocno
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
            console.log(res.data);
            var row = []
            var sum = 0
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    sum = await (Number(res.data[i].AMOUNT) / 100) * Number(res.data[i].WTAXRATE)
                    row[i] = await {
                        AMOUNT: res.data[i].AMOUNT,
                        INCOMETYPE: res.data[i].INCOMETYPE,
                        ITEMTAXTYPE: res.data[i].ITEMTAXTYPE,
                        PAYAMOUNT: res.data[i].PAYAMOUNT,
                        PAYBALANCE: res.data[i].PAYBALANCE,
                        PRODUCTCODE: res.data[i].PRODUCTCODE,
                        PRODUCTNAME: res.data[i].PRODUCTNAME,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                        REFLINEID: res.data[i].REFLINEID,
                        WTAXAMOUNT: res.data[i].WTAXAMOUNT,
                        TAXAMOUNT: (sum).toFixed(2),
                        WTAXRATE: res.data[i].WTAXRATE,
                    }
                }
                setListitem(row)
                let resdata = {
                    Totaltax1: "",
                    Vat: "",
                    sum: "",
                    listitem: row
                }
                props.sumdata('Inputtax1', resdata)
            }
        })
    }
    const Getcsv_APPAYWTAX1 = () => {
        console.log(refdocno);
        var url = "CSV_APPAYWTAX/GETALL?Top=100&REFDOCNO=" + refdocno
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
            console.log(res.data);
            var row = []
            var sum = 0
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    sum = await (Number(res.data[i].AMOUNT) / 100) * Number(res.data[i].WTAXRATE)
                    row[i] = await {
                        AMOUNT: res.data[i].AMOUNT,
                        INCOMETYPE: res.data[i].INCOMETYPE,
                        ITEMTAXTYPE: res.data[i].ITEMTAXTYPE,
                        PAYAMOUNT: res.data[i].PAYAMOUNT,
                        PAYBALANCE: res.data[i].PAYBALANCE,
                        PRODUCTCODE: res.data[i].PRODUCTCODE,
                        PRODUCTNAME: res.data[i].PRODUCTNAME,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                        REFLINEID: res.data[i].REFLINEID,
                        WTAXAMOUNT: res.data[i].WTAXAMOUNT,
                        TAXAMOUNT: (sum).toFixed(2),
                        WTAXRATE: res.data[i].WTAXRATE,
                    }
                }
                setListitem(row)
                let resdata = {
                    Totaltax1: "",
                    Vat: "",
                    sum: "",
                    listitem: row
                }
                props.sumdata('Inputtax1', resdata)
            }
        })
    }
    const SUMTotaltax = (data) => {
        console.log(data);
        var Totaltax = 0, vat = 0, sum = 0
        for (let i = 0; i < listitem.length && listitem[i].PRODUCTCODE; i++) {
            Totaltax += Number(listitem[i].PAYBALANCE)
            sum += Number(listitem[i].TAXAMOUNT)
        }

        vat = (Totaltax / 100) * 7
        Totaltax1.current.value = parseFloat(Totaltax).toFixed(2)
        Vat.current.value = parseFloat(vat).toFixed(2)

        let resdata = {
            Totaltax1: parseFloat(Totaltax).toFixed(2),
            Vat: parseFloat(vat).toFixed(2),
            sum: parseFloat(sum).toFixed(2),
            listitem: listitem
        }
        props.sumdata('Inputtax1', resdata)
    }
    const indexN = (_0, _1, _2, index) => {
        return (<div>{index + 1}</div>)
    }
    const onclick = (e) => {
        if (e.target.value && e.target.type === "number") {
            e.target.value = Number(e.target.value); e.target.select()
        }
    }
    return (
        <div onBlur={e => onBlurAction(e)} onClick={onclick}>
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            <BootstrapTable
                data={listitem}
                options={{
                    onRowClick: onRowClick,
                    noDataText: "ไม่พบข้อมูล"
                }}
                height='500'
                cellEdit={{ //แก้ไข
                    mode: 'click',
                    blurToSave: true,
                    beforeSaveCell: onBeforeSaveCell,//ก่อนเปลี่ยนค่า
                    afterSaveCell: onAfterSaveCell,//หลังเปลี่ยนค่า

                }} >
                <TableHeaderColumn dataAlign="center" width="45" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='PRODUCTCODE' editable={false} isKey> รหัสสิค้า/บริการ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='PRODUCTNAME' editable={false} > ชื่อสินค้า/บริการ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='AMOUNT' editable={false} > จำนวนเงิน </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='PAYAMOUNT' editable={false} > คงค้าง </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='INCOMETYPE' editable={false} > ประเภท </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='WTAXRATE' editable={false} > อัตรา </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='PAYBALANCE' editable={false} > ยอดชำระ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='TAXAMOUNT' editable={false} > ภาษีหัก ณ ที่จ่าย </TableHeaderColumn>
            </BootstrapTable>
            <div>
                <br></br>
                <Grid container spacing={3} direction="row">
                    <Grid item xs={8}>
                        <div> 1.กดเคลียร์รายการเดิม  <Button onClick={() => Cleartable()} variant="text">เคลียรายการเดิม</Button></div>
                        <div>2.กดแสดงสินค้า/บริการตามรายการ Invoice    <Button onClick={() => Getcsv_APPAYWTAX()} variant="text">แสดงสินค้า/บริการ</Button>
                            <Button onClick={() => Getcsv_APPAYWTAX1()} variant="text">แสดงสินค้า/บริการยอดเต็มบิล</Button>
                        </div>
                        <div>
                            3.ทุกครั้งที่แก้ไขยอดชำระให้กดปุ่ม <Button variant="text" onClick={() => SUMTotaltax()} >คำนวณภาษีหัก ณ ที่จ่ายและภาษีมูลค่าเพิ่ม</Button>


                        </div>

                    </Grid>

                    <Grid item xs={4}>
                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span className="input-group-addon">รวมยอดชำระ </span>
                                <input type="number" className="form-control " ref={Totaltax1} name="Totaltax1" />
                            </div>
                        </div>
                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span className="input-group-addon">ภาษีมูลค่าเพิ่ม </span>
                                <input type="number" className="form-control " ref={Vat} name="Vat" />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </div>

    )
}
Inputtax1.prototype = {
    parm: PropTypes.array
}
Inputtax2.prototype = {
    parm: PropTypes.array
}
function Inputtax2(props) {
    const { parm } = props
    // const { APCode, APName, table } = props
    const [listitem, setListitem] = useState(parm.Inputtax2)
    const [WHRow1, setWHRow1] = useState("");
    const [col2, setcol2] = useState("");
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [rowid, setrowid] = useState("");
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        console.log('Inputtax2', parm);
        if (parm.Inputtax2.length > 0) {
            // setListitem(parm.Inputtax2)
            setTimeout(async () => {
                let sumTax = 0
                for (let index = 0; index < parm.Inputtax2.length && parm.Inputtax2[index].Taxinvoice; index++) {
                    // if (parm.Inputtax2[index].Tax !== "") {
                    sumTax += await Number(parm.Inputtax2[index].Tax ? parm.Inputtax2[index].Tax : 0)
                    // }
                }
                if (sumTax) {
                    console.log(sumTax);
                    let data = {
                        sumTax: await parseFloat(sumTax).toFixed(2),
                        listitem: listitem
                    }
                    props.sumdata('Inputtax2', await data)
                }

            }, 200);
        } else {
            let item = []
            for (let index = 0; index < 30; index++) {
                item[index] = {
                    numrow: index + 1,
                    Taxinvoice: "",
                    Invoicedate: "",
                    PayableCode: "",
                    PayableName: '',
                    Taxdescription: "",
                    Amountbeforetax: "",
                    Tax: "",
                }
                setListitem(item)
            }
        }
    }
    const onRowClick = (data, col, id) => {
        setWHRow1(id);
        setcol2(false);
        if (col === 1) {
            if (!data.PayableCode) {
                listitem[id].Invoicedate = Moment(new Date()).format('YYYY-MM-DD')
                listitem[id].PayableCode = parm.APCode
                listitem[id].PayableName = parm.APName
                listitem[id].Condition = '1'
            }
        }
        if (data.Taxinvoice) {
            setcol2(true);
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
            if (col === 2) {
                data.btn_income = 1
                data.Income = data.Incomecode
            }
            if (col === 6) {
                data.btn_C3 = 1
            }
            if (col === 14) {
                data.btn_type = 1
                data.Type = data.Typecode
            }
            if (col === 16) {
                data.btn_C4 = 1

            }
        } else {
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
        }

    }
    const onAfterSaveCell = (row, cellName, cellValue) => {
        for (let index = 0; index < listitem.length; index++) {
            if (listitem[index].Taxinvoice === "") {
                listitem[index].Income = ""
                listitem[index].Incomecode = ""
                listitem[index].Invoicedate = ""
                listitem[index].PayableCode = ""
                listitem[index].PayableName = ""
                listitem[index].Remark = ""
                listitem[index].Taxdescription = ""
                listitem[index].Amountbeforetax = ""
                listitem[index].Tax = ""
                listitem[index].Typecode = ""
                listitem[index].Type = ""
                listitem[index].PayableCode1 = ""
                listitem[index].Condition = ''
            }
        }
        let id = row.numrow - 1
        if (cellName === 'Type' && row.Type) {
            var url = "CSWTAXTYPE/Search?Code=" + row.Type
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Typecode = await res.data[i].CODE
                        listitem[id].Type = await res.data[i].MYNAMETH
                    }
                } else {
                    listitem[id].Typecode = await ""
                    listitem[id].Type = await ""
                }
                setListitem([...listitem])
            })
        }
        if (cellName === 'Income' && row.Income) {
            var url = "CSINCOMETYPE/Search?Code=" + row.Income
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Incomecode = await res.data[i].CODE
                        listitem[id].Income = await res.data[i].MYNAMETH
                        listitem[id].Taxdescription = await res.data[i].WTAXRATE
                    }
                } else {
                    listitem[id].Incomecode = await ""
                    listitem[id].Income = await ""
                    listitem[id].Taxdescription = await ""
                }
                setListitem([...listitem])
            })
        }
        if (cellName === 'Amountbeforetax') {
            if (listitem[id].Taxinvoice) {
                console.log(cellValue);
                let res = (Number(listitem[id].Taxdescription) / 100) * Number(cellValue)
                console.log(res);
                row.Tax = parseFloat(res).toFixed(2)
            }
        }
        setTimeout(() => {
            SumCalculate()
        }, 50);

    }
    const onBeforeSaveCell = (row, cellName, cellValue) => {

    }
    const SumCalculate = async () => {
        let sumTax = 0.00
        for (let index = 0; index < listitem.length && listitem[index].Taxinvoice; index++) {
            if (listitem[index].Tax) {
                sumTax += await Number(listitem[index].Tax)
            }
        }
        let data = {
            sumTax: parseFloat(sumTax).toFixed(2),
            listitem: listitem
        }
        props.sumdata('Inputtax2', data)
    }
    function _cellButton1(cell, row) {
        var btn = row.btn_income;
        var btnShow = <i className=""></i>;
        if (btn) {
            btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('Incometype', row.numrow, "บันทึกภาษีถูกหัก ณ ที่จ่าย")} >
                <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton2(cell, row) {
        var btn = row.btn_C3;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('Apcode', row.numrow, "ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP")} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <i className=""></i>;
                break;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton3(cell, row) {
        var btn = row.btn_type;
        var btnShow = <i className=""></i>;
        if (btn) {
            btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('taxtype', row.numrow, "เลือกรายการ")} >
                <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton4(cell, row) {
        var btn = row.btn_C4;
        var btnShow = <i className=""></i>;
        if (btn) {
            btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => Switch_OtherPopup1('Apcode1', row.numrow, "ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP")} >
                <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }



    const Switch_OtherPopup1 = (type, row, dialog) => {
        setrowid(row)
        let pram = { type: type }
        setdataMultipletax(pram)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog(dialog)
        settypeFullScreenDialog(type)
    };

    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e);
        if (e) {
            let data = e[1].split('|')
            let id = rowid - 1
            if (typeFullScreenDialog === 'Incometype') {
                listitem[id].Incomecode = data[0]
                listitem[id].Income = data[1]
                listitem[id].Taxdescription = data[2]
            }
            if (typeFullScreenDialog === 'Apcode') {
                listitem[id].PayableCode = data[0]
                listitem[id].PayableName = data[1]
            }
            if (typeFullScreenDialog === 'taxtype') {
                listitem[id].Typecode = data[0]
                listitem[id].Type = data[1]
            }
            if (typeFullScreenDialog === 'Apcode1') {
                listitem[id].PayableCode1 = data[0]
            }
            // if (typeFullScreenDialog === 'Groupdataall') {
            //     Docgroupcode.current.value = data[0]
            //     Docgroup.current.value = data[1]
            //     setDocgrouptxt(data[1]);
            // }
        }
    }
    return (
        <div >
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            <BootstrapTable
                data={listitem}
                options={{
                    onRowClick: onRowClick,
                    noDataText: "ไม่พบข้อมูล"
                }}
                height='550'
                cellEdit={{ //แก้ไข
                    mode: 'click',
                    blurToSave: true,
                    beforeSaveCell: onBeforeSaveCell,//ก่อนเปลี่ยนค่า
                    afterSaveCell: onAfterSaveCell,//หลังเปลี่ยนค่า

                }} >
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField='numrow' isKey> </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="150" dataField='Taxinvoice' editable={true} > เลขที่ </TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> ประเภทเงินได้ </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="Income" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_income" editable={false} dataAlign="center" width="30" dataFormat={_cellButton1} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" hidden dataField='Incomecode'></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" editable={{ type: 'date' }} className="columnNumber" dataAlign="left" width="120" dataField='Invoicedate'> ลงวันที่ </TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> รหัสเจ้าหนี้ </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="PayableCode" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_C3" editable={false} dataAlign="center" width="30" dataFormat={_cellButton2} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='PayableName' editable={col2} > ชื่อผู้ขาย / ผู้ให้บริการ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Remark'> หมายเหตุ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Taxdescription'> อัตราภาษี </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='Amountbeforetax'> ยอดก่อนภาษี </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='Tax' editable={false}> ภาษี</TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" hidden dataField='Typecode'></TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> ประเภท </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="Type" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_type" editable={false} dataAlign="center" width="30" dataFormat={_cellButton3} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" /* className="colbuttomhidden" */ width="170"> <div align="center"> กระทำการแทน </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="PayableCode1" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_C4" editable={false} dataAlign="center" width="30" dataFormat={_cellButton4} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Condition' > เงื่อนไข </TableHeaderColumn>
            </BootstrapTable>
        </div>

    )
}
